var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopFront(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4985 26.25H8.99725V15.3125H4.49683V32.8125C4.49683 34.0225 5.50239 35 6.74704 35H24.7487C25.9934 35 26.999 34.0225 26.999 32.8125V15.3125H22.4985V26.25ZM44.6209 9.7207L38.6227 0.970703C38.2008 0.362305 37.4976 0 36.7452 0H8.25187C7.49945 0 6.79626 0.362305 6.38138 0.970703L0.383156 9.7207C-0.615376 11.1768 0.453475 13.125 2.25365 13.125H42.7504C44.5436 13.125 45.6124 11.1768 44.6209 9.7207ZM35.9998 33.9062C35.9998 34.5078 36.5061 35 37.1249 35H39.3751C39.9939 35 40.5002 34.5078 40.5002 33.9062V15.3125H35.9998V33.9062Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopFront);
export default __webpack_public_path__ + "static/media/shop-front.f7246d336ec6fc4a5b6d20366294f982.svg";
export { ForwardRef as ReactComponent };